module.exports = __webpack_public_path__ + "img/nathalie_de_loeper_praticienne_shiatsu.66931b55.webp";